export const isTulsa = (countyName) => (countyName || '').match(new RegExp('tulsa', 'gi'));

// Tulsa's assessor unit/lot (situsSuffix) belongs in the situs address only on mobile home
// records, written with a '#'. Mirrors the backend rule so the screens match the saved address.
export const getTulsaSitusSuffix = (taxType, situsSuffix) => {
  if ((taxType || '').toString().toLowerCase() !== 'm') return null;
  const suffix = (situsSuffix === null || situsSuffix === undefined ? '' : situsSuffix).toString().trim();
  if (!suffix || suffix === '0') return null;
  return suffix.startsWith('#') ? suffix : `#${suffix}`;
};

export const isCanadian = (countyName) => (countyName || '').match(new RegExp('canadian', 'gi'));

export const isCandianPayrollProfile = (name) => (name || '').match(new RegExp('Payroll', 'gi'));

export const isCountyMatchedInArr = (countyArr, countyName) => countyArr.find((c) => (c || '').match(new RegExp(countyName, 'gi')));

export const filterForCountySpecificProfiles = (profile, countyName) => {
  const { countySpecific } = profile.value || {};
  // if profile is not county specific then 'countySpecific' is empty array/undefined
  if (Array.isArray(countySpecific) && countySpecific.length > 0) {
    if (!isCountyMatchedInArr(countySpecific, countyName)) {
      return false;
    }
  }
  return true;
};
